import { isMobile } from 'react-device-detect';
import { Request } from '../../../components/Request';
import { ChatActions } from 'components/ChatActions';

export const FOCUSED_PRIVATE_CHATS = 'FOCUSED_PRIVATE_CHATS';
export const FOCUSED_FRIEND_LIST = 'FOCUSED_FRIEND_LIST';

export const PENDING_FRIEND_REQUESTS_CHANGED = 'PENDING_FRIEND_REQUESTS_CHANGED';
export const CHANGE_FRIEND_TAB = 'CHANGE_FRIEND_TAB';
export const SET_SELECTED_CHAT = 'SET_SELECTED_CHAT';
export const SET_MY_CHAT_ROOMS = 'SET_MY_CHAT_ROOMS';
export const TOGGLE_CHAT_SIDEBAR = 'TOGGLE_CHAT_SIDEBAR';
export const TOGGLE_CHAT_USERLIST_SIDEBAR = 'TOGGLE_CHAT_USERLIST_SIDEBAR';
export const TOGGLE_CHAT_RULES_VISIBLE = 'TOGGLE_CHAT_RULES_VISIBLE';
export const MAIN_CHAT_USERLIST_TOGGLE = 'MAIN_CHAT_USERLIST_TOGGLE';
export const MAIN_CHAT_VISIBLE_TOGGLED_ON = 'MAIN_CHAT_VISIBLE_TOGGLED_ON';
export const MAIN_CHAT_MINIMIZED_TOGGLE = 'MAIN_CHAT_MINIMIZED_TOGGLE';
export const SET_EDIT_MESSAGE = 'SET_EDIT_MESSAGE';
export const END_EDIT_MESSAGE = 'END_EDIT_MESSAGE';
export const SUBMIT_MESSAGE_EDIT_BEGIN = 'SUBMIT_MESSAGE_EDIT_BEGIN';
export const SUBMIT_MESSAGE_EDIT_SUCCESS = 'SUBMIT_MESSAGE_EDIT_SUCCESS';
export const SUBMIT_MESSAGE_EDIT_FAIL = 'SUBMIT_MESSAGE_EDIT_FAIL';

export const EDIT_MESSAGE_TEXT_UPDATE = 'EDIT_MESSAGE_TEXT_UPDATE';
export const SUBMIT_MESSAGE_DELETE_BEGIN = 'SUBMIT_MESSAGE_DELETE_BEGIN';
export const SUBMIT_MESSAGE_DELETE_SUCCESS = 'SUBMIT_MESSAGE_DELETE_SUCCESS';
export const SUBMIT_MESSAGE_DELETE_FAIL = 'SUBMIT_MESSAGE_DELETE_FAIL';

export const SUBMIT_MESSAGE_REMOVE_BEGIN = 'SUBMIT_MESSAGE_REMOVE_BEGIN';
export const SUBMIT_MESSAGE_REMOVE_SUCCESS = 'SUBMIT_MESSAGE_REMOVE_SUCCESS';
export const SUBMIT_MESSAGE_REMOVE_FAIL = 'SUBMIT_MESSAGE_REMOVE_FAIL';

export const CHAT_MESSAGE_DELETE_HIGHLIGHT_BEGIN = 'CHAT_MESSAGE_DELETE_HIGHLIGHT_BEGIN';
export const CHAT_MESSAGE_DELETE_HIGHLIGHT_END = 'CHAT_MESSAGE_DELETE_HIGHLIGHT_END';

export const VISIBLE_USERLIST_UPDATED = 'VISIBLE_USERLIST_UPDATED';

export const GET_CLOSED_PRIVATE_CHATS_BEGIN = 'GET_CLOSED_PRIVATE_CHATS_BEGIN';
export const GET_CLOSED_PRIVATE_CHATS_SUCCESS = 'GET_CLOSED_PRIVATE_CHATS_SUCCESS';
export const GET_CLOSED_PRIVATE_CHATS_FAIL = 'GET_CLOSED_PRIVATE_CHATS_FAIL';

export const CHAT_GENERAL_STATE_UPDATE = 'CHAT_GENERAL_STATE_UPDATE';
export const CHAT_ROOM_DESCRIPTION_UPDATES = 'CHAT_ROOM_DESCRIPTION_UPDATES';

import { ChatRoom } from 'models/ChatRoom';
import { ChatMessage } from 'models/ChatMessage';
import { changeMatchmakingTab } from './matchmaking';
import { possibleTabs } from '../reducers/matchmaking';
import { Dashboard } from 'components/Dashboard';

export const friendStates = {
	messages: 'messages',
	friends: 'friends',
	ignored: 'ignored',
	search: 'search',
};

export const chatRoomDescriptionUpdated = () => {
	return {
		type: CHAT_ROOM_DESCRIPTION_UPDATES,
	};
};

export const updateGeneralChatUnreadMessageState = () => (dispatch, getState) => {
	const chatState = getState().chat;

	const chatsWithUnreadMessages = {};
	const chatsWithNewMentions = {};
	let aChatHasUnreadMessages = false;
	let aChatHasNewMentions = false;

	const stateUpdates = {};
	for(let [_, chatRoom] of ChatRoom.activeChats) {
		if(chatRoom.chatMessages.hasNewMentions) {
			chatsWithNewMentions[chatRoom.id] = true;
			aChatHasNewMentions = true;
		}
		// A muted room's messages don't count; its mentions do.
		const muted = chatRoom.isMuted ? chatRoom.isMuted() : false;
		if(chatRoom.chatMessages.hasUnreadMessages() && (!muted || chatRoom.chatMessages.hasNewMentions)) {
			chatsWithUnreadMessages[chatRoom.id] = true;
			aChatHasUnreadMessages = true;
		}
	}

	if(aChatHasUnreadMessages !== chatState.aChatHasUnreadMessages) {
		stateUpdates.aChatHasUnreadMessages = aChatHasUnreadMessages;
	}
	if(aChatHasNewMentions !== chatState.aChatHasNewMentions) {
		stateUpdates.aChatHasNewMentions = aChatHasNewMentions;
	}
	if(!_.isEqual(chatsWithUnreadMessages, chatState.chatsWithUnreadMessages)) {
		stateUpdates.chatsWithUnreadMessages = chatsWithUnreadMessages;
	}
	if(!_.isEqual(chatsWithNewMentions, chatState.chatsWithNewMentions)) {
		stateUpdates.chatsWithNewMentions = chatsWithNewMentions;
	}

	if(!_.size(stateUpdates)) {
		return;
	}
	dispatch({
		type: CHAT_GENERAL_STATE_UPDATE,
		payload: {
			...stateUpdates
		}
	});
};

export const chatMessageDeleteHighlightBegin = (chatMessages, player) => {

	return {
		type: CHAT_MESSAGE_DELETE_HIGHLIGHT_BEGIN,
		payload: {
			context: chatMessages,
			player: player
		}
	};
};

export const chatMessageDeleteHighlightEnd = (chatMessages, player) => {
	return {
		type: CHAT_MESSAGE_DELETE_HIGHLIGHT_END
	};
};

export const submitMessageDelete = (message) => (dispatch, getState) => {

};

const doPendingMessageSubmit = (dispatch, message, text) => {
	const chatMessagePayload = {
		chatMessageId: message.send_id,
		idType: ChatMessage.idTypes.SEND_ID,
		text,
	};
	let firstSendPromise = null;
	if(ChatMessage.activeSendPromises[message.send_id]) {
		firstSendPromise = ChatMessage.activeSendPromises[message.send_id];
	}
	else {
		console.error('Error submitting edit: the pending message has no send in flight', message);
		throw new Error('Error Submitting Edit');
	}

	dispatch({
		type: SUBMIT_MESSAGE_EDIT_BEGIN,
		payload: {
			...chatMessagePayload
		}
	});
	return firstSendPromise
		.then((messageId) => {
			if(!messageId) {
				// The send failed; editing with no message_id would post the text as a new message.
				// The edited text is already on the failed message, so retrying it sends the edit.
				throw new Error('The message being edited was not sent');
			}
			dispatch({
				type: SUBMIT_MESSAGE_EDIT_SUCCESS,
				payload: {
					...chatMessagePayload
				}
			});
			return messageId;
		})
		.catch((error) => {
			dispatch({
				type: SUBMIT_MESSAGE_EDIT_FAIL,
				payload: {
					...chatMessagePayload
				}
			});
			throw error;
		});
};

const submitRealMessageEdit = (dispatch, message, text, messageId) => {
	const chatMessagePayload = {
		chatMessageId: messageId,
		idType: ChatMessage.idTypes.DB_ID,
		text,
	};

	dispatch({
		type: SUBMIT_MESSAGE_EDIT_BEGIN,
		payload: {
			...chatMessagePayload
		}
	});
	return Request.apiv1('chat/send', {
			message_id: messageId,
			message: text
		})
		.then((response) => {
			Dashboard.performOpenSearchUpdate(response);
			dispatch({
				type: SUBMIT_MESSAGE_EDIT_SUCCESS,
				payload: {
					...chatMessagePayload
				}
			});
		})
		.catch((error) => {
			Request.generalJsonError(error);
			dispatch({
				type: SUBMIT_MESSAGE_EDIT_FAIL,
				payload: {
					...chatMessagePayload
				}
			});
		});
};

export const submitMessageEdit = (message, text) => (dispatch, getState) => {
	if(!message) {
		console.error('submitMessageEdit needs a message');
		return;
	}
	let originalIdType = message.id ? ChatMessage.idTypes.DB_ID : ChatMessage.idTypes.SEND_ID;
	if(originalIdType === ChatMessage.idTypes.SEND_ID) {
		return doPendingMessageSubmit(dispatch, message, text)
			.then((messageId) => {
				return submitRealMessageEdit(dispatch, message, text, messageId);
			});
	}
	else {
		return submitRealMessageEdit(dispatch, message, text, message.id);
	}
};


export const chatMessageEditTextChange = (text) => {
	return {
		type: EDIT_MESSAGE_TEXT_UPDATE,
		payload: text,
	};
};
export const endChatMessageEditMode = () => {
	return {
		type: END_EDIT_MESSAGE,
	};
};
export const setChatMessageToEditMode = (message) => {
	return {
		type: SET_EDIT_MESSAGE,
		payload: {
			chatMessageId: message.id ? message.id : message.send_id,
			idType: message.id ? ChatMessage.idTypes.DB_ID : ChatMessage.idTypes.SEND_ID,
			text: message.message
		}
	};
};

export const toggleChatVisibleOn = () => {
	return {
		type: MAIN_CHAT_VISIBLE_TOGGLED_ON
	};
};

export const toggleMainChatMinimized = () => {
	return {
		type: MAIN_CHAT_MINIMIZED_TOGGLE
	};
};

export const toggleChatRules = () => {
	return {
		type: TOGGLE_CHAT_RULES_VISIBLE,
		payload: null
	};
};

export const showChatRules = () => {
	return {
		type: TOGGLE_CHAT_RULES_VISIBLE,
		payload: true
	};
};

export const userlistUpdated = (userlist) => {
	const userlistList = {};
	for(let user of userlist.users.keys()) {
		userlistList[user] = true;
	}
	return {
		type: VISIBLE_USERLIST_UPDATED,
		payload: userlistList
	};
};

export const toggleChatSidebar = (setTo = null) => {
	return {
		type: TOGGLE_CHAT_SIDEBAR,
		payload: setTo,
	};
};

export const toggleChatUserlistSidebar = (setTo = null) => (dispatch) => {
	dispatch({
		type: TOGGLE_CHAT_USERLIST_SIDEBAR,
		payload: setTo,
	});
	ChatActions.chatFocus();
};

export const setChatRoomAsActive = (chat) => (dispatch) => {
	if (chat && chat.chatGroup === ChatRoom.activeChats) {
		chat.chatGroup.selectedChat = chat;
		chat.chatMessages.markAllRead();
		ChatActions.chatFocus(chat.id);
	}
	dispatch({
		type: SET_SELECTED_CHAT,
		payload: chat
	});
	dispatch(updateGeneralChatUnreadMessageState());
};

export const setMyChatRoomList = (chatRooms) => {
	return {
		type: SET_MY_CHAT_ROOMS,
		payload: chatRooms
	};
};

export const mainChatUserlistToggle = () => (dispatch) => {
	dispatch({
		type: MAIN_CHAT_USERLIST_TOGGLE,
	});
	ChatActions.chatFocus();
};

export const changeFriendTab = (tab, clicked) => {
	return {
		type: CHANGE_FRIEND_TAB,
		payload: {
			tab,
		}
	};
};
export const focusedPrivateChats = () => {
	return {
		type: FOCUSED_PRIVATE_CHATS
	};
};
export const focusedFriendList = () => {
	return {
		type: FOCUSED_FRIEND_LIST
	};
};

export const getClosedPrivateChats = () => (dispatch, getState) => {
	dispatch({
		type: GET_CLOSED_PRIVATE_CHATS_BEGIN
	});
	Request.apiv1Get('chat/direct_message_list', { open_chats: false })
		.then((response) => {
			dispatch({
				type: GET_CLOSED_PRIVATE_CHATS_SUCCESS,
				payload: response.private_chat
			});
			this.parseInitialList(response.private_chat);
		})
		.catch(() => {
			dispatch({
				type: GET_CLOSED_PRIVATE_CHATS_FAIL
			});
		});
};

export const pendingFriendRequestsChanged = (count) => (dispatch, getState) => {
	const state = getState();
	if(count === state.chat.pendingFriendRequestCount) {
		return;
	}
	dispatch({
		type: PENDING_FRIEND_REQUESTS_CHANGED,
		payload: count
	});
};